import {
  DELIVERY_SEARCH, DELIVERY_SEARCH_SUCCESS, DELIVERY_SEARCH_FAILURE, CLEAR_DELIVERY_SEARCH_PARAMS
} from './mutation-types'

export default {
  state: {
    today: null,
    days: null,
    delivery: null,
    yearMonth: null,
    currentStartDate: null,
    prevStartDate: null,
    nextStartDate: null,
    searchParams: null
  },
  getters: {
    today: state => {
      return state.today
    },
    days: state => {
      return state.days
    },
    delivery: state => {
      return state.delivery
    },
    yearMonth: state => {
      return state.yearMonth
    },
    currentSearchDate: state => {
      return state.currentSearchDate
    },
    prevStartDate: state => {
      return state.prevStartDate
    },
    nextStartDate: state => {
      return state.nextStartDate
    },
    deliverySearchParams: state => {
      return state.searchParams
    }
  },
  actions: {
    [DELIVERY_SEARCH] ({dispatch, state, commit}, params = null) {
      var url = '/delivery'

      state.searchParams = params.data
      dispatch('apiGet', {url: url, data: params.data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(DELIVERY_SEARCH_FAILURE, res.data)
          } else {
            commit(DELIVERY_SEARCH_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [CLEAR_DELIVERY_SEARCH_PARAMS] ({state}) {
      state.searchParams = null
    }
  },
  mutations: {
    [DELIVERY_SEARCH_FAILURE] (state, data) {
      console.log('DELIVERY_SEARCH_FAILURE')
    },
    [DELIVERY_SEARCH_SUCCESS] (state, data) {
      console.log('DELIVERY_SEARCH_SUCCESS')
      state.today = data['today']
      state.days = data['days']
      state.delivery = data['delivery']
      state.yearMonth = data['year-month']
      state.currentStartDate = data['current-start-date']
      state.prevStartDate = data['prev-start-date']
      state.nextStartDate = data['next-start-date']
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/delivery.js